import { LayoutService } from './../../shared/layout/layout.service';
import { Injectable, NgZone } from '@angular/core';

import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { catchError, map, tap } from 'rxjs/operators';

import { ApiResponse, ApiPagedResponse, PaginationInfo } from "app/client-core/api-response-models";
import { ApiService } from "../api.service";
import { Bucket } from '../dtos/buckets.model';
import { Subject } from 'rxjs/Subject';
import { Router } from '@angular/router';
import { CampaignThemeListItemDto, CampaignThemeCategoryLookupItemDto, CreateThemeCategoryCommand, SaveCampaignThemeCommand, CampaignThemeDto, CampaignThemeId, CampaignThemeSearch, CampaignThemeTacticListItemDto, MyCampaignSearch } from '../dtos/campaigns.model';
import { BrandListItemDto } from '../dtos/brands.model';
import { HttpHeaders } from '@angular/common/http';
import { CalendarComponent } from 'app/shared/components/calendar/calendar.component';
import { DomSanitizer } from '@angular/platform-browser';
//import { TacticAssetslistItemDTO } from '../dtos/tactics.model';
import * as moment from 'moment';
import { BsModalService } from 'ngx-bootstrap';

@Injectable()
export class CampaignService {

    //event used to notify when campaign theme is saved, info is requested or theme is selected
    public campaignThemeSaved: Subject<CampaignThemeId>;
    public showCampaignThemeInfo: Subject<CampaignThemeId>;
    public selectCampaignThemeInfo: Subject<CampaignThemeId>;
    public newFavoriteAdded: Subject<CampaignThemeId>;
    public newCampaignThemeSearchModelArrived: Subject<CampaignThemeSearch>;
    public newMyCampaignSearchModelArrived: Subject<MyCampaignSearch>;
    public campaignThemeCopied: Subject<any>;
    public campaignThemeArchived: Subject<any>;
    public showAllCampaignsChanged: Subject<boolean>;
    public campaignSelected: Subject<any>;
    public campaignSelectedToCopy: Subject<number>;
    public campaignSelectedToEdit: Subject<any>;
    public campaignsStorageUpdated: Subject<any>;
    public refreshMyCampaigns: Subject<any>;
    public programEdited: Subject<any>;
    public campaignThemeSelectedToEdit: Subject<any>;
    public campaignThemeSelectedToInfo: Subject<any>;
    public notify: Subject<number>;
    public deleteProgram: Subject<number>;
    public programDeleted: Subject<boolean>;

    constructor(
        private apiService: ApiService,
        private router: Router,
        private zone: NgZone,
        private _sanitizer: DomSanitizer,
        private layoutService: LayoutService,
        private route: Router,
        private modalService: BsModalService
    ) {

        this.campaignThemeSaved = new Subject<CampaignThemeId>();
        this.showCampaignThemeInfo = new Subject<CampaignThemeId>();
        this.selectCampaignThemeInfo = new Subject<CampaignThemeId>();
        this.newFavoriteAdded = new Subject<CampaignThemeId>();
        this.newCampaignThemeSearchModelArrived = new Subject<CampaignThemeSearch>();
        this.newMyCampaignSearchModelArrived = new Subject<MyCampaignSearch>();
        this.campaignThemeCopied = new Subject<any>();
        this.campaignThemeArchived = new Subject<any>();
        this.showAllCampaignsChanged = new Subject<boolean>();
        this.campaignSelected = new Subject<any>();
        this.campaignSelectedToCopy = new Subject<number>();
        this.campaignSelectedToEdit = new Subject<any>();
        this.campaignsStorageUpdated = new Subject<any>();
        this.refreshMyCampaigns = new Subject<any>();
        this.campaignThemeSelectedToEdit = new Subject<any>();
        this.campaignThemeSelectedToInfo = new Subject<any>();
        this.programEdited = new Subject<any>();
        this.deleteProgram = new Subject<number>();
        this.programDeleted = new Subject<boolean>();
        this.notify = new Subject<number>();
    }

    /**
     * Returns lookup list of projects
     * @param params
     */
    getCategories(params?: any): Observable<ApiResponse<ApiPagedResponse<CampaignThemeListItemDto>>> {
        console.log('>>getCategories', JSON.stringify(params));
        return this.apiService.get<ApiPagedResponse<CampaignThemeListItemDto>>('campaigns', params);
    }

    getAllCategories(params?: any): Observable<ApiResponse<ApiPagedResponse<CampaignThemeListItemDto>>> {
        console.log('>>getCategories', JSON.stringify(params));
        return this.apiService.get<ApiPagedResponse<CampaignThemeListItemDto>>('campaigns/all', params);
    }

    getMyCampaigns(params?: any, showLoading = true): Observable<ApiResponse<ApiPagedResponse<CampaignThemeListItemDto>>> {
        let headers: HttpHeaders = new HttpHeaders();
        headers = headers.append('showLoading', JSON.stringify(showLoading));
        console.log('>>getCategories', JSON.stringify(params));
        if (params) {
            for(const p in params) {
                if (!params[p]) {
                    delete params[p];
                }
            }
        }
        return this.apiService.get<ApiPagedResponse<CampaignThemeListItemDto>>('campaigns/MyCampaignsContainer', params, headers);
    }

    getCampaignThemeTactics(params?:any): Observable<ApiResponse<ApiPagedResponse<CampaignThemeTacticListItemDto>>> {
        console.log(`>>getCampaignThemeTactics for`, JSON.stringify(params));
        return this.apiService.get<ApiPagedResponse<CampaignThemeTacticListItemDto>>(`campaigns/campaign-theme-tactics`, params);
    }

    getCampaignTheme(id: number): Observable<ApiResponse<CampaignThemeDto>> {
        console.log(`>>getCampaignTheme for ${id}`);
        return this.apiService.get<CampaignThemeDto>(`campaigns/${id}`);
    }

    /**
     * Returns lookup list of projects
     * @param params
     */
    getThemeCategoryLookup(params?: any): Observable<ApiResponse<ApiPagedResponse<CampaignThemeCategoryLookupItemDto>>> {
        console.log('>>getThemeCategoryLookup', JSON.stringify(params));
        return this.apiService.get<ApiPagedResponse<CampaignThemeCategoryLookupItemDto>>('campaigns/lookup/theme-categories', params);
    }

    getBrandsLookup(params?: any): Observable<ApiResponse<ApiPagedResponse<BrandListItemDto>>> {
        console.log('>>getBrandsLookup', JSON.stringify(params));
        return this.apiService.get<ApiPagedResponse<BrandListItemDto>>('campaigns/lookup/brands', params);
    }

    getRoles(id?: any): Observable<any> {
        console.log('>>getBrandsLookup', JSON.stringify(id));
        return this.apiService.get<any>(`campaigns/getroles/${id}`);
    }

    getCustomizations(id?: any): Observable<any> {
        console.log('>>getBrandsLookup', JSON.stringify(id));
        return this.apiService.get<any>(`campaigns/getcustomizations/${id}`);
    }

    createThemeCategory(command: CreateThemeCategoryCommand): Observable<ApiResponse<number>> {
        return this.apiService.post<number>(`campaigns/theme-categories`, command);
    }

    createCampaignTheme(command: SaveCampaignThemeCommand): Observable<ApiResponse<number>> {
        return this.apiService.post<number>(`campaigns`, command);
    }

    updateCampaignTheme(id: number, command: SaveCampaignThemeCommand): Observable<ApiResponse<number>> {
        return this.apiService.post<number>(`campaigns/${id}`, command);
    }

    getMyCampaignsCalendar(params?: any): Promise<any> {
        console.log('>>campaigns calendar', JSON.stringify(params));
        return new Promise((resolve, reject) => {
            let headers: HttpHeaders = new HttpHeaders();
            headers = headers.append('showLoading', 'false');
            this.apiService.get<any>('campaigns/calendar', params, headers).subscribe(data => {
                resolve(data);
            }, err => {
                reject(err);
            });
        });
    }

    getMyCampaignsPromise(params?: any): Promise<ApiResponse<ApiPagedResponse<CampaignThemeListItemDto>>> {
        console.log('>>getCategories', JSON.stringify(params));
        let headers: HttpHeaders = new HttpHeaders();
        headers = headers.append('showLoading', 'false');
        return new Promise((resolve, reject) => {
            return this.apiService
                        .get<ApiPagedResponse<CampaignThemeListItemDto>>('campaigns/calendar', params, headers)
                        .subscribe(response => {
                            resolve(response);
                        }, error => {
                            reject(error);
                        });
        });
    }

    archiveProgram(id: number) {
        return this.apiService.put<number>(`programs/archive/${id}`, {});
    }

    archiveProgramList(ids: string) {
        return this.apiService.put<number>(`programs/archive-list?programs=${ids}`, {});
    }

    getCampaignThemeTypes(params?: any): Observable<ApiResponse<ApiPagedResponse<{id: number, name: string}>>> {
        console.log('>>campaign-theme-type', JSON.stringify(params));
        return this.apiService.get<ApiPagedResponse<BrandListItemDto>>('campaigns/campaign-theme-type', params);
    }

    getStoredCalendar() {
        const calendar = localStorage.getItem('calendar_events');
        if (calendar) {
            return JSON.parse(calendar);
        }
        return null;
    }

    getStoredCalendarOriginalEvents() {
        const calendar = localStorage.getItem('calendar_original_itens');
        if (calendar) {
            return JSON.parse(calendar);
        }
        return null;
    }

    getProgramOverview(params?: any): Observable<ApiResponse<any>> {
        return this.apiService.get<any>('programs/overview', params);
    }

    getProgramOverviewDetails(params?: any): Observable<ApiResponse<any>> {
        return this.apiService.get<any>('programs/overview-details', params);
    }

    getProgramsDraft(params?: any): Observable<ApiResponse<any>> {
        return this.apiService.get<any>('programs/draft', params);
    }

    setCampaignThemeId(programId: number, campaignThemeId: number): Observable<ApiResponse<any>> {
        return this.apiService.put<any>(`programs/${programId}/set-campaignthemeid/${campaignThemeId}`, {});
    }

    getSpMyCampaigns(params?: any): Observable<ApiResponse<ApiPagedResponse<CampaignThemeListItemDto>>> {
        return this.apiService.get<ApiPagedResponse<CampaignThemeListItemDto>>('campaigns/my-campaigns-calendar', params, null);
    }

    deleteProgramFromDatabase(id: number): Observable<ApiResponse<boolean>> {
        return this.apiService.post<boolean>(`programs/delete-program/${id}`, {});
    }
}



// WEBPACK FOOTER //
// ./src/app/client-core/services/campaign.service.ts